import api from "../utils/api";

/**
 * Tabs this user is allowed to see in the dashboard navigation.
 *
 * The selection is managed from the Step 2 admin portal
 * (Settings -> EnViz Web Tab Access) and stored in app_tabs / user_tab_access.
 * Each entry carries { id, label, path, order, parent_id, tab_key }; labels are
 * unique across the tree, so the header matches its nav items on label.
 *
 * Throws on failure so the caller can decide to fail open and show everything
 * rather than render an empty navigation.
 */
export const getVisibleTabs = async (username) => {
  const response = await api.get("/tabs", {
    params: username ? { username } : undefined,
  });
  return Array.isArray(response.data) ? response.data : [];
};
